export interface Readings {
    reading: Reading[];
}

export class Reading {

    constructor(
        public FV: string,
        public LT: string,
        public P: string,
        public S: string,
        public V: string,
        public VN: string,
        public C: string,
        public contractId: number,
        public readingDate: string,
        public endBillingPeriod: string,
        public eqNumber: string,
        public estimatedDays: number,
        public mrType: string,
        public realDays: number,
        public startBillingPeriod: string,
        public readingStatus: string,
        public supplyType: string,
        public unit: string,
        public showEstimationsDays?: boolean
    ) { }

}

export class ReadingsFactory {
    static create(reading: any): Reading {
        return new Reading(
            reading.FV,
            reading.LT,
            reading.P,
            reading.S,
            reading.V,
            reading.VN,
            reading.C,
            reading.contractId,
            reading.readingDate,
            reading.endBillingPeriod,
            reading.eqNumber,
            reading.estimatedDays,
            reading.mrType,
            reading.realDays,
            reading.startBillingPeriod,
            reading.readingStatus,
            reading.supplyType,
            reading.unit
        );
    }
}
